<template>
    <div>
        
        <sub-visual
        subTabNone
        sh="개인정보처리방침"
        bg="/images/sub/visual/sv6.jpg">
        </sub-visual>

        <section class="section">
            <v-container>
                <section class="page-section">
                    <h4 class="tit tit--sm line-height-1 mb-8 mb-lg-16">
                        개인정보 수집 및 이용 동의
                    </h4>
                    <v-card elevation="0" outlined style="border-color: #ececec">
                        <div class="pa-20">
                            <ul class="dot-texts page-text page-text--sm">
                                <li class="dot-text dot-text--sm">
                                    수집 및 이용목적 : 효성 CMS 출금이체를 통한 요금수납, 소득공제 영수증 발급
                                </li>
                                <li class="dot-text dot-text--sm">
                                    수집항목 : 성명, 생년월일, 연락처, 예금주명, 계좌번호, 예금주 휴대전화번호
                                </li>
                                <li class="dot-text dot-text--sm">
                                    보유 및 이용 기간 : 수집, 이용 동의 일로부터 자동이체 종료일(해지일) 까지
                                </li>
                                <li class="dot-text dot-text--sm">
                                    신청자는 개인정보 수집 및 이용을 거부할 권리가 있으며, 권리 행사 시 출금이체 신청이 거부될 수 있습니다.
                                </li>
                            </ul>
                        </div>
                    </v-card>
                </section>
                <section class="page-section">
                    <h4 class="tit tit--sm line-height-1 mb-8 mb-lg-16">
                        개인정보 제 3자 제공 동의
                    </h4>
                    <v-card elevation="0" outlined style="border-color: #ececec">
                        <div class="pa-20">
                            <ul class="dot-texts page-text page-text--sm">
                                <li class="dot-text dot-text--sm">
                                    개인정보를 제공 받는 자: 효성에프엠에스(주), 금융기관, 통신사, 국세청(홈택스)
                                </li>
                                <li class="dot-text dot-text--sm">
                                    개인정보를 제공받는 자의 이용목적 : 자동이체서비스 제공 및 자동이체 동의 사실 통지
                                </li>
                                <li class="dot-text dot-text--sm">
                                    제공하는 개인정보의 항목 : 성명, 생년월일, 연락처, 은행명, 예금주명, 계좌번호, 예금주 휴대전화번호
                                </li>
                                <li class="dot-text dot-text--sm">
                                    개인정보를 제공 받는 자의 개인정보 보유 및 이용 기간 : 동의일로부터 자동이체의 종료일(해지일)까지. 단, 관계 법령에 의거 일정기간 동안 보관
                                </li>
                                <li class="dot-text dot-text--sm">
                                    신청자는 개인정보에 대해 수납업체가 제3자에 제공하는 것을 거부할 수 있습니다. 단, 거부 시 자동이체 신청이 처리되지 않습니다.
                                </li>
                            </ul>
                        </div>
                    </v-card>
                </section>
            </v-container>
        </section>

    </div>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        SubVisual,
    },
};
</script>

<style scoped>
</style>